import {BASE_PATH, BASE_PATH_EXTENSION, BASE_PATH_EXTENSION_ADMIN} from "../../utils/constants";
import {getToken} from "../Auth/token";
import axios from "axios";

const urlBase = `${BASE_PATH}${BASE_PATH_EXTENSION}/admin/provider`;

export async function getProviderApi(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/get-provider`, props, config)
}

export async function showProviderApi() {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/list`, null, config)
}

export async function createProviderApi(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/create`, props, config)
}

export async function updateProviderApi(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/update`, props, config)
}

